// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemDatasetExtended } from '../../../assets/icons/extended/entities/gem-dataset.svg?react';
import { createIcons } from '../../Icon';
const GemDatasetIcon = /* @__PURE__ */ createIcons('GemDataset', {
    extended: GemDatasetExtended
});
GemDatasetIcon.supportedTypes = ['extended'];
GemDatasetIcon.category = 'entities';
export default GemDatasetIcon;
